import './app/styles/index.scss'

import {
	init,
} from '@tma.js/sdk-react'
import {
	StrictMode,
} from 'react'
import {
	createRoot,
} from 'react-dom/client'
import {
	ToastContainer,
} from 'react-toastify'

import {
	AuthTelegramInitializer,
} from '@/modules/auth'

import {
	AppRouter,
} from './app/providers/app-router'
import {
	ProvidersTree,
} from './app/providers/builder'

init()

createRoot(document.getElementById('root')!).render(
	<StrictMode>
		<ProvidersTree>
			<AuthTelegramInitializer>
				<AppRouter />
			</AuthTelegramInitializer>
			<ToastContainer icon={false} />
		</ProvidersTree>
	</StrictMode>,
)
